const CREATOR_DETAIL_KEYS = new Set([
    'CREATOR',
    'CREATOR_WITH_ATTRIBUTION',
    'DESIGNER',
    'ARTIST',
    'ATTRIBUTED_TO',
    'CIRCLE_OF',
    'IN_THE_STYLE_OF',
    'ICONIC_DESIGN',
    'BRAND',
    'AFTER',
    'AFTER_SDATA_1127',
    'OF_THE_PERIOD',
    'SIMILAR_TO',
]);

export const isCreatorDetailKey = (detailKey: string | null | undefined): boolean =>
    !!detailKey && CREATOR_DETAIL_KEYS.has(detailKey);
